import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import { CheckBox as CheckBoxIcon, DoneAll } from "@material-ui/icons";

import { UnoxColors } from "../../../constants/theme";
import { StationPermission } from "../../../Models/StationPermission";

type StationPermissionSelection = StationPermission & {
  isSelected: boolean;
};

type AddPermissionsProps = {
  availablePermissionStations: StationPermission[];
  addPermissions: (permissions: StationPermission[]) => void;
  cancel: () => void;
};

const AddPermissions: React.FC<AddPermissionsProps> = (props) => {
  const [availableStations, setAvailableStations] = useState<
    StationPermissionSelection[]
  >([]);

  useEffect(() => {
    const mappedStations = props.availablePermissionStations.map((st) => {
      return { ...st, isSelected: false };
    });
    setAvailableStations(mappedStations);
  }, [props.availablePermissionStations]);

  const handleAddPermissions = () => {
    const list = availableStations.filter((st) => st.isSelected);
    props.addPermissions(list);
  };

  const handleCheckboxCheck = (stationNumber: number) => {
    const newStations = availableStations.map((st) =>
      st.stationNumber === stationNumber
        ? { ...st, isSelected: !st.isSelected }
        : st
    );
    setAvailableStations(newStations);
  };

  const selectAll = () => {
    const newStations = availableStations.map((st) => ({
      ...st,
      isSelected: true,
    }));
    setAvailableStations(newStations);
  };

  return (
    <Grid container direction="column">
      <Typography variant="h5">Opret ny aftale</Typography>
      <Typography variant="body2" style={{ marginTop: 10 }}>
        Marker de stationer din prisspotter skal passe:
      </Typography>

      {availableStations.map((stationSelection) => (
        <FormControlLabel
          key={stationSelection.stationNumber}
          control={
            <Checkbox
              checked={stationSelection.isSelected}
              style={{ height: 10 }}
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              onChange={() =>
                handleCheckboxCheck(stationSelection.stationNumber)
              }
              color="primary"
            />
          }
          label={
            <Typography variant="body2">
              {stationSelection.stationName}
            </Typography>
          }
        />
      ))}
      <Button onClick={() => selectAll()} size="small" startIcon={<DoneAll />} style={{maxWidth: 184, paddingLeft: 0}}>
        Vælg alle stationer
      </Button>
      <Grid
        item
        container
        direction="row"
        justify="space-between"
        style={{ marginTop: 10 }}
      >
        <Button
          style={{
            backgroundColor: UnoxColors.Red,
            color: UnoxColors.White,
            maxWidth: 160,
            marginRight: 10,
            flex: 1,
          }}
          variant="contained"
          onClick={() => props.cancel()}
        >
          Annuller
        </Button>
        <Button
          style={{
            backgroundColor: UnoxColors.Green,
            color: UnoxColors.White,
            maxWidth: 160,
            flex: 1,
          }}
          variant="contained"
          onClick={() => handleAddPermissions()}
        >
          Opret aftale
        </Button>
      </Grid>
    </Grid>
  );
};

export default AddPermissions;
